module.exports = __webpack_public_path__ + "img/download-data-by-freepik.b459f48a.png";